import React from "react";
import { service_property_management } from "../../../data/servicesData";
import { Button } from "../../../components/Button";
import { NavLink } from "react-router-dom";

const PropertyManagementSection = () => {
  return (
    <div className="flex flex-col w-full items-center px-[5vw] sm:px-[10vw] xl:px-[15vw]">
      <div className="py-16 space-y-8 text-center xl:w-[60vw]">
        <div className="space-y-2">
          <h1 className="text-xl lg:text-2xl font-playfair uppercase">
            {service_property_management.title}
          </h1>
          <p className='italic'>{service_property_management.sub_title}</p>
        </div>
        <div className="space-y-2 text-justify">
          <p>{service_property_management.para1}</p>
          <p>{service_property_management.para2}</p>
        </div>
        <div>
          <NavLink to="/rent">
            <Button name="View Available Properties" className="px-5 py-2 bg-yellow-light text-ash-500"/>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default PropertyManagementSection;
